import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react"
import { useTranslation } from "react-i18next"
import "./ContactSection.css"

const contactRows = [
  {
    icon: MapPin,
    accent: "blue",
    label: "Address",
    value: "Al Sulay, Riyadh, Saudi Arabia",
    href: "https://maps.google.com/?q=Al+Sulay,+Riyadh,+Saudi+Arabia",
  },
  {
    icon: Mail,
    accent: "green",
    label: "Email",
    value: "info@roadsreflectors.com",
    href: "mailto:info@roadsreflectors.com",
  },
  {
    icon: Phone,
    accent: "yellow",
    label: "Administrator",
    value: "0504 465 224",
    href: "tel:+966504465224",
  },
  {
    icon: Phone,
    accent: "red",
    label: "Financial Administrator",
    value: "0500 455 042",
    href: "tel:+966500455042",
  },
]

export function ContactSection() {
  const { t } = useTranslation()
  return (
    <section id="contact" className="contact-panel">
      <div className=" contact-panel__wrap">
        <div className="contact-panel__card">
          {/* decorative ring, echoing the about section mark */}
          <div className="contact-panel__glow" aria-hidden="true" />

          <div className="contact-panel__grid">
            {/* Left: heading */}
            <div className="contact-panel__intro">
              <span className="contact-panel__badge">{t("Get In Touch")}</span>
              <h2 className="contact-panel__title">
                {t("Talk to our road safety team")}
              </h2>
              <p className="contact-panel__desc">
                {t("Questions about a product, a quote, or an ongoing project? We're one call or email away.")}
              </p>
              <a href="mailto:info@roadsreflectors.com" className="btn-pill btn-pill--brand contact-panel__btn">
                {t("Send Us a Message")}
                <span className="btn-pill__arrow">
                  <ArrowUpRight size={14} />
                </span>
              </a>
            </div>

            {/* Right: contact rows */}
            <div className="contact-panel__list">
              {contactRows.map((row, index) => {
                const Icon = row.icon
                return (
                  <a
                    key={row.label}
                    href={row.href}
                    className={`contact-row contact-row--${row.accent}`}
                    style={{ "--row-index": index }}
                  >
                    <span className="contact-row__icon">
                      <Icon size={18} />
                    </span>
                    <span className="contact-row__text">
                      <span className="contact-row__label">{t(row.label)}</span>
                      <span
                        className="contact-row__value"
                        dir={row.href.startsWith("tel:") ? "ltr" : undefined}
                      >
                        {t(row.value)}
                      </span>
                    </span>
                    <span className="contact-row__go">
                      <ArrowUpRight size={16} />
                    </span>
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}